export default {
    'name': 'image',
    'label': 'patent-view.images',
    'version': '1.0',
    'getComponent': () => import('./Thumb.vue'),
    'tabIndex': 0,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/image',
    'selfHandelPadding': true,
};
